import type { Visit } from './services/visits'

export function fieldSurveyorSurveyDestination(visit: Pick<Visit, 'id' | 'status'>): string {
  if (visit.status === 'in_review' || visit.status === 'released' || visit.status === 'archived') {
    return `/visits/${visit.id}/survey/report`
  }
  if (visit.status === 'in_progress') {
    return `/visits/${visit.id}/survey/walkthrough`
  }
  return `/visits/${visit.id}/survey`
}

export function fieldSurveyorSurveyActionLabel(visit: Pick<Visit, 'status'>): string {
  if (visit.status === 'in_review' || visit.status === 'released' || visit.status === 'archived') return 'View report'
  if (visit.status === 'in_progress') return 'Resume survey'
  return 'Start survey'
}
